import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";

const BADGE_MAX_NUMBER = 99;

export default class WazeHeaderChatIcon extends Component {
  @service appEvents;
  @tracked chatSDK = null;
  @tracked unreadCount = 0;

  constructor(...args) {
    super(...args);
    this.appEvents.on("waze:chat:ready", this, this.wazeChatReady);
    this.appEvents.on("waze:chat:unread", this, this.wazeChatUnread);
  }

  willDestroy(...args) {
    this.appEvents.off("waze:chat:ready", this, this.wazeChatReady);
    this.appEvents.off("waze:chat:unread", this, this.wazeChatUnread);
    super.willDestroy(...args);
  }

  @action
  wazeChatReady(sdk) {
    this.chatSDK = sdk;
    this.unreadCount = this.chatSDK.getUnreadChatCount();
  }

  @action
  wazeChatUnread() {
    if (this.chatSDK) {
      this.unreadCount = this.chatSDK.getUnreadChatCount();
    }
  }

  @action
  toggleChatVisibility() {
    if (this.chatSDK) {
      this.chatSDK.setVisibility(!this.chatSDK.getVisibility());
    }
  }

  get badgeText() {
    return this.unreadCount > BADGE_MAX_NUMBER
      ? `${BADGE_MAX_NUMBER}+`
      : this.unreadCount;
  }

  get buttonClasses() {
    const classes = ["icon", "btn-flat"];
    if (!this.chatSDK) {
      classes.push("wz-header-chat-icon-disabled");
    }
    return classes.join(" ");
  }

  <template>
    <li class="wz-header-chat-icon">
      <DButton
        class={{this.buttonClasses}}
        @icon="w-chat"
        title={{i18n "waze.chat.header.title"}}
        @action={{this.toggleChatVisibility}}
      />
      {{#if this.unreadCount}}
        <div class="wz-header-chat-icon-badge">{{this.badgeText}}</div>
      {{/if}}
    </li>
  </template>
}
